export function getUTCDateFromString(dateStr) {
	if (!dateStr) return null;
	const [year, month, day] = dateStr.split('-').map(Number);
	return new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
}

export function toIsoDateString(dateValue) {
	const dateString = String(dateValue ?? '').trim();
	let dateParts = dateString.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);

	if (dateParts) {
		return formatIsoDateParts(dateParts[1], dateParts[2], dateParts[3]);
	}

	dateParts = dateString.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
	if (dateParts) {
		return formatIsoDateParts(dateParts[3], dateParts[2], dateParts[1]);
	}

	// Checkout calendar callbacks can provide the selected date using the
	// customer-facing format, for example "Sat 1 Aug 2026".
	dateParts = dateString.match(/^(?:(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun)[a-z]*,?\s+)?(\d{1,2})\s+([a-z]+)\s+(\d{4})$/i);
	if (dateParts) {
		const month = getMonthNumber(dateParts[2]);
		if (month) {
			return formatIsoDateParts(dateParts[3], month, dateParts[1]);
		}
	}

	return null;
}

function getMonthNumber(monthName) {
	const months = {
		jan: 1,
		feb: 2,
		mar: 3,
		apr: 4,
		may: 5,
		jun: 6,
		jul: 7,
		aug: 8,
		sep: 9,
		oct: 10,
		nov: 11,
		dec: 12
	};

	return months[String(monthName).slice(0, 3).toLowerCase()] ?? null;
}

function formatIsoDateParts(year, month, day) {
	const numericYear  = Number(year);
	const numericMonth = Number(month);
	const numericDay   = Number(day);
	const date = new Date(Date.UTC(numericYear, numericMonth - 1, numericDay));

	if (
		date.getUTCFullYear() !== numericYear ||
		date.getUTCMonth() + 1 !== numericMonth ||
		date.getUTCDate() !== numericDay
	) {
		return null;
	}

	return `${numericYear.toString().padStart(4, '0')}-${numericMonth.toString().padStart(2, '0')}-${numericDay.toString().padStart(2, '0')}`;
}

export const getTodayUTC = () => new Date(Date.UTC(
	new Date().getUTCFullYear(),
	new Date().getUTCMonth(),
	new Date().getUTCDate()
));
